<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import { useFleetStore } from '@/stores/fleetStore'
import { useBattleSimulatorStore } from '@/stores/battleSimulatorStore'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const fleetStore = useFleetStore()
const battleSimulatorStore = useBattleSimulatorStore()

const selectedFleet = ref<number | null>(null)

const isDefending = computed(() => gameStore.modalType === 'battleSimulatorCopyDefendingFleet')

const fleetOptions = computed(() =>
  [...fleetStore.fleets.values()]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((fleet) => ({ value: fleet.id, label: `${fleet.name} (${t('command.battleSimulator.ships', { count: fleet.nrOfShips })})` }))
)

const selectAndSubmit = (val: string | number) => {
  selectedFleet.value = Number(val)
  submit()
}

const submit = () => {
  if (selectedFleet.value) {
    battleSimulatorStore.copyFromFleet(selectedFleet.value, isDefending.value ? 'defending' : 'attacking')
    gameStore.modalType = ''
  }
}
</script>

<template>
  <SmallModel :title="isDefending ? t('command.battleSimulator.copyToDefending') : t('command.battleSimulator.copyToAttacking')">
    <div class="p-2">
      <p class="pb-2 text-subtext">{{ t('command.battleSimulator.selectFleetToCopy', { type: isDefending ? t('command.battleSimulator.defending') : t('command.battleSimulator.attacking') }) }}</p>
      <FormSelect
        :modelValue="selectedFleet"
        @update:modelValue="selectAndSubmit"
        :options="fleetOptions"
        :placeholder="t('command.battleSimulator.selectFleet')"
      />
      <p class="pt-2 text-subtext">{{ t('command.battleSimulator.replaceWarning', { type: isDefending ? t('command.battleSimulator.defending') : t('command.battleSimulator.attacking') }) }}</p>
    </div>
  </SmallModel>
</template>

<style scoped lang="scss"></style>
